interface FilterSectionAvailabilityOptions {
  activeFilterCount: number
  isDeferred: boolean
  isError?: boolean
  isLoading: boolean
  optionCount: number
}

/** Disables a filter section only after its catalog settles with no usable options. */
export function isFilterSectionDisabled({
  activeFilterCount,
  isDeferred,
  isError = false,
  isLoading,
  optionCount,
}: FilterSectionAvailabilityOptions): boolean {
  return (
    !isDeferred &&
    !isLoading &&
    !isError &&
    activeFilterCount === 0 &&
    optionCount === 0
  )
}
